import { FC } from 'react'
import Breadcrumb, { TProps as TBreadcrumbProps } from 'components/Breadcrumb'
import Typography from 'components/Typography'
import Button from 'components/Button'
import Image from 'components/Image'
import styles from './Hero.module.scss'

export type TProps = {
  breadcrumbList?: TBreadcrumbProps['list']
  title?: string | undefined | null
  text?: string | undefined | null
  button?: {
    label: string
    href: string
    onClick?: () => void
  }
  image: {
    src: string
    alt: string
  }
}

const Hero: FC<TProps> = ({ breadcrumbList, title, text, image, button }) => {
  return (
    <div className={styles.ecRegionHero}>
      <div className={styles.ecRegionHeroContent}>
        {breadcrumbList && <Breadcrumb list={breadcrumbList} variant="wrap" />}
        <div className={styles.ecRegionHeroCityCopies}>
          {title && (
            <Typography
              variant="TitleBig"
              as="h1"
              bold
              data-testid="ecRegionTitle"
            >
              {title}
            </Typography>
          )}
          {text && <Typography>{text}</Typography>}
        </div>
        {button && (
          <Button
            element="a"
            theme="pink"
            size="big"
            href={button.href}
            className={styles.ecRegionHeroCta}
            onClick={button.onClick}
          >
            {button.label}
          </Button>
        )}
      </div>
      <div className={styles.ecRegionHeroImageWrapper}>
        <Image
          src={image.src}
          fill
          alt={image.alt}
          className={styles.ecRegionHeroImage}
          priority
        />
      </div>
    </div>
  )
}

export default Hero
